import {
  GET_ERRORS,
  CLEAR_ERRORS,
  POSTING_LOADING,
  CLEAR_LOADING,
  SEND_CODE,
  SIGNUP_MEMBER,
  LOGIN_MEMBER,
  SEND_CODE_LOGIN,
  FORGET_PASSWORD,
  GET_MEMBER,
  SEND_CODE_EMAIL,
  CHANGE_EMAIL,
  EMAIL_VERIFICATION,
  SEND_CODE_MOBILE,
  CHANGE_MOBILE,
  CHANGE_PASSWORD,
} from './types';
import { Cookies } from 'react-cookie';
import axios from 'axios';

/**
 * Sets the session
 * @param {*} member
 */
const setSession = member => {
  let cookies = new Cookies();
  if (member) cookies.set('member', JSON.stringify(member), { path: '/' });
  else cookies.remove('member', { path: '/' });
};

export const postLoading = () => {
  return {
    type: POSTING_LOADING,
  };
};
export const clearLoading = () => {
  return {
    type: CLEAR_LOADING,
  };
};

export const sendCode = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/send_code', data)
    .then((res) => {
      dispatch({
        type: SEND_CODE,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const signUp = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/signup', data)
    .then((res) => {
      dispatch({
        type: SIGNUP_MEMBER,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const loginMember = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/login', data)
    .then((res) => {
      setSession(res.data);
      dispatch({
        type: LOGIN_MEMBER,
        payload: res.data,
      });
    })
    .catch((err) => {
      setSession(null);
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const sendCodeLogin = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/send_code_login', data)
    .then((res) => {
      dispatch({
        type: SEND_CODE_LOGIN,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const forgetPassword = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/forget_password', data)
    .then((res) => {
      setSession(res.data);
      dispatch({
        type: FORGET_PASSWORD,
        payload: res.data,
      });
    })
    .catch((err) => {
      setSession(null);
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const logoutMember = (history) => (dispatch) => {
  let cookies = new Cookies();
  const member = cookies.get('member');

  dispatch(postLoading());
  
  const options = {
    data: JSON.stringify(member),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    url: '/api/auth/logout'
  };

  setSession(null);

  axios(options)
    .then((res) => {
      history.push('/members');
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getMember = () => (dispatch) => {
  
  axios.get('/api/auth/get_member')
    .then((res) => {
      dispatch({
        type: GET_MEMBER,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const sendCodeEmail = () => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/send_code_email')
    .then((res) => {
      dispatch({
        type: SEND_CODE_EMAIL,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const changeEmail = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/change_email', data)
    .then((res) => {
      dispatch({
        type: CHANGE_EMAIL,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const emailVerification = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/email_verification', data)
    .then((res) => {
      dispatch({
        type: EMAIL_VERIFICATION,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const sendCodeMobile = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/send_code_mobile', data)
    .then((res) => {
      dispatch({
        type: SEND_CODE_MOBILE,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const changeMobile = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/change_mobile', data)
    .then((res) => {
      dispatch({
        type: CHANGE_MOBILE,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const changePassword = (data) => (dispatch) => {
  dispatch(postLoading());
  dispatch(clearErrors());
  
  axios
    .post('/api/auth/change_password', data)
    .then((res) => {
      dispatch({
        type: CHANGE_PASSWORD,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch(clearLoading());
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS,
  };
};
